<template>
    <v-card :loader="loader">
        <div v-padding="3">
            <div v-margin.bottom="3">
                <v-text type="title">
                    {{ product.name }}
                </v-text>
            </div>


            <v-row>
                <v-col xs="3">
                    <div v-margin.bottom="2">

                        <v-text v-if="isManual" type="subheadling">
                            Готовность от 15-ти минут до 4-х часов <br>
                            Понедельник — Пятница <br> 7:00 — 18:00 (мск) <br>
                            Суббота, Воскресенье выходные
                        </v-text>

                        <v-text v-else type="subheadling">
                            Готовность в режиме онлайн, круглосуточно
                        </v-text>
                    </div>

                    <div v-for="link, key in product.links" :key="key">
                        <v-link :to="link" target="_blank">
                            Пример отчета {{ product.links.length > 1 ? key + 1 : '' }}
                        </v-link>
                    </div>
                </v-col>
                <v-col>
                    <div :class="theme.exampleDescription" v-html="product.fullDescription"></div>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
    import theme from './theme.scss';

    export default {
        name: 'report-example',
        props: {
            loader: Boolean,
            product: {
                type: Object,
                default() {
                    return {};
                }
            },
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
        },
        computed: {
            isKO() {
                return /^(кредитный отчёт)/i.test(this.product.name);
            },
            isManual() {
                return ["Досье", "Проверка СБ"].includes(this.product.name);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ReportExample.vue?5bc8a80d